<template>
	<div class="detail-banner-wrapper" :class="{ 'large-screen': isWideScreen }">
		<van-swipe
			v-if="images.length"
			:loop="false"
			:show-indicators="false"
			ref="swiper"
			@change="onSwipe"
		>
			<van-swipe-item
				v-for="(item, index) in images"
				:key="item.thpf_url + index"
				:class="{ 'head-photo-fallback': item.isHeadPhotoFallback }"
			>
				<nio-image
					draggable="false"
					:src="cdn(item.thpf_url, '/thumbnail/!900x900r', true)"
					loaderWidth="100%"
					loaderHeight="auto"
					:height="'375px'"
					:width="isWideScreen ? '375px' : '100%'"
					:useWideScreen="isWideScreen"
					v-sd-exp:VehicleDetailExpo="getTrackingInfo(index, 'exposure')"
					v-sd-clk:VehicleDetailClick="getTrackingInfo(index, 'click')"
				/>
			</van-swipe-item>
		</van-swipe>

		<div class="indicator-area" v-if="images.length">
			<div class="indicator-mask"></div>
			<div class="indicator-row indicator-row--quick">
				<div>
					<span class="active">{{ activeIndex + 1 }}</span>
					<span>/{{ images.length }}</span>
				</div>
			</div>
		</div>

		<div class="top-mask"></div>
	</div>
</template>

<script>
import { cdn } from '@/util/imgCdn'
import hybrid from '@/util/nativeHybrid'
import { getFastListingPhotos } from '@/util/fast-listing'

export default {
	name: 'FastListingBanner',
	props: ['car'],
	data() {
		return {
			activeIndex: 0
		}
	},
	computed: {
		images() {
			return getFastListingPhotos(this.car)
		},
		isWideScreen() {
			return hybrid.isWideScreen()
		}
	},
	mounted() {
		this.pointerListeners = []
		this.$nextTick(() => {
			if (this.$refs.swiper) {
				this.$refs.swiper.$el.childNodes.forEach($dom => {
					this.supportMouseEvent($dom)
				})
			}
		})
	},
	beforeDestroy() {
		this.pointerListeners.forEach(({ dom, handlers }) => {
			Object.keys(handlers).forEach(eventName => {
				dom.removeEventListener(eventName, handlers[eventName])
			})
		})
		this.pointerListeners = []
	},
	methods: {
		cdn,
		onSwipe(index) {
			this.activeIndex = index
		},
		getTrackingInfo(index, action) {
			return {
				page: '二手车车辆详情页',
				label_name: this.car.$$track_label_name,
				tag: this.car.$$track_tags,
				module_name: '车辆图片',
				button_name: action === 'click' ? '车辆图片' : undefined,
				position_rank: 1,
				position_in_rank: index + 1,
				position_in_number: this.images.length,
				track_sign:
					action === 'click'
						? 'aMall.b4307.click.VehicleDetailClick'
						: 'aMall.b4307.exposure.VehicleDetailExpo'
			}
		},
		supportMouseEvent(dom) {
			const createHandler = touchEventName => e => {
				const evt = document.createEvent('Event')
				evt.initEvent(touchEventName, true, true)
				evt.touches = [e]
				dom.dispatchEvent(evt)
			}
			const handlers = {
				pointerdown: createHandler('touchstart'),
				pointermove: createHandler('touchmove'),
				pointerup: createHandler('touchend')
			}

			Object.keys(handlers).forEach(eventName => {
				dom.addEventListener(eventName, handlers[eventName])
			})
			this.pointerListeners.push({ dom, handlers })
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.detail-banner-wrapper {
	width: 100%;
	position: relative;

	.top-mask {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		height: 120px;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
	}
	.van-swipe {
		height: 375px;
		.van-swipe-item {
			height: 375px;
			:deep(.nio-image-container) {
				width: 100%;
				.nio-image {
					object-fit: cover;
				}
			}
			&.head-photo-fallback {
				:deep(.nio-image-container) {
					.nio-image {
						object-fit: contain;
					}
				}
			}
		}
	}
	&.large-screen {
		.van-swipe {
			.van-swipe-item {
				:deep(.nio-image-container) {
					.nio-image {
						object-fit: contain;
					}
				}
			}
		}
	}

	.indicator-area {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 52px;
		color: #ffffff;
		.indicator-mask {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
		}
		.indicator-row {
			position: relative;
			height: 100%;
			display: flex;
			align-items: center;
			padding: 0 20px;
			font-size: 14px;
			&--quick {
				justify-content: flex-end;
			}
			.active {
				font-size: 20px;
				font-weight: 500;
			}
		}
	}
}
</style>
